import { render, staticRenderFns } from "./lightBox.vue?vue&type=template&id=37171cd3"
import script from "./lightBox.vue?vue&type=script&lang=js"
export * from "./lightBox.vue?vue&type=script&lang=js"
import style0 from "./lightBox.vue?vue&type=style&index=0&id=37171cd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports